import { render, staticRenderFns } from "./trainingCard.vue?vue&type=template&id=757f54ba&scoped=true&"
import script from "./trainingCard.vue?vue&type=script&lang=js&"
export * from "./trainingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f54ba",
  null
  
)

export default component.exports